import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Avatar, IconButton, Menu, MenuItem, Badge, TextField, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));


const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 675,
  borderRadius: 2,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  py: 2,
  px: 4,
};
interface LongMenuProps {
  openFn: () => void;
}
const LongMenu: React.FC<LongMenuProps> = ({ openFn }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 216,
            width: "20ch",
          },
        }}
      >
        <MenuItem onClick={openFn}>View Comments</MenuItem>
      </Menu>
    </div>
  );
};
export default function ActionModal({ rowData }: any) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div>
      <LongMenu openFn={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex justify-between mb-4">
            <p className="font-bold text-base"> {rowData.shopName}</p>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex justify-between">
            <div>
              <div className="border border-slate-300	py-3 px-6 rounded-lg  mt-3">
                <p className="text-sm font-semibold py-2 border-b">
                  Request Details
                </p>
                <div className="ml-2 flex">
                  <div className="mr-4 mt-3">
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                    >
                      <Avatar>YS</Avatar>
                    </StyledBadge>
                  </div>
                  <div className="mt-3">
                    <div>
                      <p className="text-sm font-semibold text-left text-slate-700">
                        {rowData.name}
                      </p>
                      <p className="font-medium	text-left text-slate-700 flex items-center mt-1 text-xs">
                        <img
                          src={"/assets/icons/mobileIcon.svg"}
                          alt=""
                          className="h-4 mr-1"
                        />
                        {rowData?.hmMobile}
                      </p>
                    </div>
                  </div>

                  <div className="flex mt-3">
                    <div className="flex ml-2">
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Address
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData?.shopAddr}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Fleet Demand
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData?.noOfPilot}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Time Shift
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData.startTime}-{rowData.endTime}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Start Date
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData.startDate}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            <FormControl fullWidth>
            <label htmlFor="email" className="text-left mb-3">
                  Additional Comments:
                </label>
            <TextField id="outlined-multiline-static" multiline disabled rows={4}
 defaultValue={rowData.requirement}></TextField>
            </FormControl>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
